<template>
  <b-container fluid class="subnav">
    <b-row>
      <b-col v-for="item in subnav" md="3">
        <div class="subnav-item" v-bind:style="{ backgroundImage: 'url(./assets/' + item.image + ')' }" v-scroll-to="'#' + item.anchor">
          <h2>{{ item.title }}</h2>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'subnav',
  props: ['subnav'],
}
</script>

<style lang="scss">
.subnav {
  overflow: hidden;
  .row {
    margin-left: -30px;
    margin-right: -30px;
    width: auto;
    @media all and (max-width: $screen-md) {
      margin-left: -30px;
      margin-right: -30px;
    }
    @media all and (max-width: $screen-md - 1) {
      margin-left: -15px;
      margin-right: -15px;
    }
  }
}
.subnav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(25vw - 30px);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  z-index: 0;
  text-align: center;
  color: $white;
  cursor: pointer;
  background-color: $black;
  transition: all ease-in .3s;
  @include sans-font(bold);
  @media all and (max-width: $screen-md - 1) {
    height: 70vw;
    margin-bottom: 1em;
    left: -15px;
    width: calc(100% + 30px);
    max-height: 150px;
  }
  @media all and (max-width: $screen-sm) {
    max-height: 400px;
  }
  // &:after {
  //   position: absolute;
  //   width: 100%;
  //   height: 100%;
  //   content: "";
  //   z-index: -1;
  //   background: rgba($black2, 0);
  //   transition: all ease-in .3s;
  // }
  &:hover {
    background-color: $black2;
  }
  h2 {
    @include sans-font(bold);
  }
}
</style>
